<template>
    <v-navigation-drawer :model-value="visible" location="right" temporary fixed width="420" @update:model-value="toggle">
        <v-container min-width="415">
            <v-row>
                <v-col>
                    <v-toolbar flat color="white">
                        <h3>{{ $t('filter.title') }}</h3>
                        <v-spacer />
                        <a @click="reset">{{ $t('filter.reset') }}</a>
                    </v-toolbar>
                </v-col>
            </v-row>

            <slot name="default" />

            <v-row class="mar-l-0 mar-t-10 pt-3">
                <v-col>
                    <v-btn class="mr-8 ml-3" color="primary" @click="confirm">{{ $t('filter.confirm') }}</v-btn>
                    <v-btn @click="cancel">{{ $t('filter.cancel') }}</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-navigation-drawer>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component({
    emits: ['cancel', 'confirm', 'update:visible', 'reset']
})
export default class FilterDrawer extends Vue {
    @Prop({ required: true, type: Boolean })
    private visible!: boolean;
    @Prop({ required: false, type: Boolean, default: true })
    private closeable!: boolean;

    private cancel() {
        this.$emit('cancel');
    }
    private confirm() {
        this.$emit('confirm');
    }
    private toggle(value: boolean) {
        this.$emit('update:visible', value);
    }
    private reset() {
        this.$emit('reset');
    }
}
</script>

<style scoped>
.v-application a {
    color: #0d47a1;
    cursor: pointer;
}
.v-navigation-drawer__scrim {
    z-index: 8888;
}
</style>
